@for (toast of orderedToasts(); track toast) {
  <ngb-toast
    class="w-100"
    [ngClass]="toast.classname"
    [autohide]="toast.autohide ?? true"
    [delay]="toast.delay || 5000"
    (hidden)="removeToast(toast)"
  >
    <div class="p-1 d-flex justify-content-between align-items-start">
      @if (isTemplate(toast)) {
        <div>
          <ng-template *ngTemplateOutlet="$any(toast.body)" />
        </div>
      } @else {
        <div class="d-flex">
          @if (toast.icon) {
            <i class="icon {{toast.icon}} pe-2"></i>
          }
          <span class="fw-bold">{{ toast.body }}</span>
        </div>
      }
      <div class="d-flex gap-2">
        @if (showShortcutInToast() && !isCoveringActive() && !isMobile) {
          <button
            class="toast-settings btn p-0 d-inline-flex align-items-center text-reset"
            (click)="onNavigateToToastSettings()"
            data-testid="toastSettingsButton"
          >
            <i class="icon ni-settings"></i>
          </button>
        }
        <i
          class="icon ni-close cursor-pointer"
          (click)="removeToast(toast)"
        ></i>
      </div>
    </div>
  </ngb-toast>
}
